import { type MutationError, trpc } from '@/shared/api';

interface UseSetColorOptionsOptions {
  readonly onSuccess?: () => void;
}

/** 색상 옵션 저장 — 목록에서 빠진 기존 행은 삭제된다(동기화). */
export const useSetColorOptions = ({ onSuccess }: UseSetColorOptionsOptions = {}) => {
  const mutation = trpc.productManagement.products.setColorOptions.useMutation({ onSuccess });

  const error: MutationError | null = mutation.error;

  return {
    setColorOptions: mutation.mutate,
    isPending: mutation.isPending,
    error,
    /** 지난 오류를 지운다 — 같은 오류 줄을 쓰는 업로드를 보낼 때 옛 저장 오류가 남지 않게. */
    reset: mutation.reset,
  };
};
